var _circle, _circle2, _path, _path2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 154,
    viewBox: "0 0 159 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.915,
    cy: 78.5,
    r: 75.5,
    fill: "#D1E4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.4557,
    cy: 53.4557,
    r: 53.4557,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5461 15.5337C66.3008 16.4274 63.7823 21.1173 59.9227 21.1173C37.518 21.1173 19.3555 39.0311 19.3555 61.1288C19.3555 63.9644 15.6664 65.549 14.9705 62.8002C14.2045 59.7744 13.7979 56.6084 13.7979 53.3488C13.7979 31.8649 31.4628 14.4487 53.2536 14.4487C56.4545 14.4487 59.5663 14.8245 62.5461 15.5337Z",
    fill: "#D1E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1314 53.4557C99.1314 78.6817 78.6817 99.1314 53.4557 99.1314C28.2297 99.1314 7.78002 78.6817 7.78002 53.4557C7.78002 28.2297 28.2297 7.78002 53.4557 7.78002C78.6817 7.78002 99.1314 28.2297 99.1314 53.4557ZM88.4422 93.8729C79.0662 101.996 66.835 106.911 53.4557 106.911C23.9329 106.911 0 82.9785 0 53.4557C0 23.9329 23.9329 0 53.4557 0C82.9785 0 106.911 23.9329 106.911 53.4557C106.911 66.7988 102.023 79.0001 93.9386 88.3661L135.72 129.219L130.28 134.781L88.4422 93.8729Z",
    fill: "#001535",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2179_56774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 152,
    height: 151
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.915,
    cy: 78.5,
    r: 75.5,
    fill: "#D1E4FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2179_56774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.847 111.031L112.275 99.6033L166.775 148.83L150.074 165.532L100.847 111.031Z",
    fill: "#013B8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.0bc8739edcf134c73d5483155fc676d8.svg";
export { ForwardRef as ReactComponent };